import React from 'react';

import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import { useThemeContext } from 'global/ThemeContext/ThemeContext';
import baseTheme from 'styles/theme'; // Importa o tema base (com fontes, spacing, etc.)

const DynamicStyledThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dynamicThemeColors = useThemeContext(); // Pega as cores dinâmicas do nosso contexto

  // Monta o objeto de tema final para styled-components
  const finalStyledTheme = {
    ...baseTheme, // Começa com o tema base
    COLORS: {
      // Mescla dentro do objeto 'COLORS' existente no baseTheme
      ...baseTheme.COLORS, // Mantém outras cores estáticas do baseTheme
      // Sobrescreve as cores com os valores dinâmicos
      BACKGROUND_PRIMARY: dynamicThemeColors.background.primary,
      BACKGROUND_SECONDARY: dynamicThemeColors.background.secondary,
      TEXT_PRIMARY: dynamicThemeColors.text.primary,
      TEXT_SECONDARY: dynamicThemeColors.text.secondary,
      PRIMARY: dynamicThemeColors.primary,
    },
  };

  // Passa o tema final e dinâmico para o ThemeProvider do styled-components
  return <StyledThemeProvider theme={finalStyledTheme}>{children}</StyledThemeProvider>;
};

export default DynamicStyledThemeProvider;
